<template>
  <div class="comp-se-card">
    <div class="se-nav">
      <div
        v-for="(item, i) in link"
        :key="item.id"
        :class="['header-nav', navActive === i ? 'navActive' : '']"
        @click="changeMenu(item)"
      >
        <span v-if="i != 0" class="nav-leftline"></span>
        <span class="nav-text">
          <svg class="icon-nav-style" aria-hidden="true">
            <use :xlink:href="`#${item.meta.icon}`"></use>
          </svg>
          {{ item.meta.title }}
        </span>
      </div>
    </div>
    <div class="se-content">
      <div class="content" v-for="item in menuItems" :key="item.id">
        <div @click="handleEntrance(item.path)">
          <div class="se-box">
            <div class="se-icon">
              <!-- <svg-icon icon-class="download"></svg-icon> -->
              <svg class="icon-style" aria-hidden="true">
                <use :xlink:href="`#${item.meta.portalIcon}`"></use>
              </svg>
            </div>
            <span class="se-message">{{ item.meta.title }}</span>
          </div>
        </div>
      </div>
      <div class="placeholder" v-for="v in 5" :key="v"></div>
    </div>
  </div>
</template>

<script>
// 未登录时的快捷入口
import link from "./mock/entrance";
import Mgr from "../services/SecurityService";
import { getRoutes } from "@/api/role";
// 处理菜单的链接
function getMenu(link) {
  link = JSON.parse(link);
  //去除运行管理
  link = link.slice(1);
  link.forEach((el, i) => {
    el.pid = i;
  });
  const arr = [];
  const menu = JSON.parse(JSON.stringify(link));
  menu.forEach(el => {
    el.children = [];
  });
  function getLink(tree) {
    tree.forEach(el => {
      if (el.children.length) {
        el.children.forEach(al => {
          al.pid = el.pid;
        });
        if (el.redirect != null && el.redirect != "") {
          arr.push(el);
        } else {
          return getLink(el.children);
        }
      }
    });
  }
  getLink(link);
  menu.forEach(el => {
    arr.forEach(item => {
      if (item.pid === el.pid) {
        el.children.push(item);
      }
    });
  });
  return menu;
}

export default {
  name: "Entrance",
  data() {
    return {
      userMgr: new Mgr(),
      isLogin: false,
      link: getMenu(link),
      navActive: 0,
      items: []
    };
  },
  computed: {
    menuItems() {
      if (this.items.length >= 12) {
        const arr = this.items.slice(0, 11);
        const item = this.items[this.items.length - 1];
        item.meta.portalIcon = "icongengduo-big";
        item.meta.title = "更多";
        item.path = "/dashborad";
        arr.push(item);
        return arr;
      }
      return this.items;
    }
  },
  methods: {
    changeMenu(item) {
      this.navActive = item.pid;
      this.items = item.children;
    },
    handleEntrance(link) {
      if (this.isLogin) {
        window.open("/admin" + link);
        // window.open('http://localhost:9529/admin/#' + link)
      } else {
        this.userMgr.signIn();
      }
    },
    async checkLogin() {
      var isLogin = await this.userMgr.isLogin();
      this.isLogin = isLogin;
      if (this.isLogin) {
        const { token } = await this.$store.dispatch("user/getInfo");
        if (token) {
          getRoutes()
            .then(res => {
              const menu = getMenu(res.Result);
              this.link = menu;
              this.items = this.link[0].children;
            })
            .catch(err => {
              console.log(err);
            });
        }
      } else {
        this.items = this.link[0].children;
      }
    }
  },
  created() {
    this.checkLogin();
  }
};
</script>

<style lang="scss" scoped>
.comp-se-card {
  position: relative;
  width: 100%;
  padding-bottom: 40px;
  text-align: center;
  .se-nav {
    // left: 50%;
    // transform: translate(-50%);
    height: 64px;
    background: #ffffff;
    box-shadow: 0px 2px 11px 0px rgba(47, 84, 235, 0.1);
    border-radius: 8px;
    margin-top: -32px;
    position: relative;
    z-index: 9;
    display: flex;
    // flex-direction: row;
    // justify-content: space-evenly;
    align-items: center;
    overflow: hidden;
    // transform: scale(1);
    .header-nav {
      // width: 236px;
      flex: 1;
      height: 64px;
      display: flex;
      flex-direction: row;
      color: #333333;
      transition: all 1s;
      :hover {
        color: $primary-color;
        cursor: pointer;
      }
      .nav-leftline {
        display: inline-block;
        width: 1px;
        height: 64px;
        background: #eeeeee;
      }
      .nav-text {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: 600;
        .menu_icon {
          font-size: 16px;
          margin-right: 8px;
        }
      }
    }
  }
  .se-content {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    white-space: normal;
    cursor: pointer;
    .se-info {
      padding-top: 16px;
      padding-right: 24px;
    }
    .se-rightBox {
      padding-right: 0;
    }
    .content {
      width: 176px;
      height: 150px;
      margin-top: 24px;
    }
    .placeholder {
      width: 176px;
      height: 0;
    }
  }
}
.navActive {
  background: $primary-color;
  :hover {
    color: #ffffff !important;
  }
  .nav-text {
    color: #ffffff;
  }
  // border-radius: 8px 8px 8px 8px;
}

.se-box {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 176px;
  height: 150px;
  background: #ffffff;
  border-radius: 4px;
  &:hover {
    width: 172px;
    height: 146px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(154, 168, 222, 0.2);
    border-radius: 4px;
    border: 2px solid $primary-color;
  }
  .se-null-box {
    height: 0;
  }
  .se-icon {
    width: 56px;
    height: 56px;
    padding: 24px 60px;
  }
  .se-message {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
  .icon-style {
    width: 100%;
    height: 100%;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    color: $primary-color;
  }
}
.icon-nav-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
